import React, { Component } from 'react';
import styles from './styles.scss';
import { validator } from '../../../utils';
import ENUMS from '../../../enums';

class HourPairDiscountItem extends Component {
  onChangeDiscountValue = (e, itemKey) => {
    const value = e.target.value;
    if (
      !value ||
      ((validator.isNumber(value) || validator.isPersianOrEnglishNumber(value)) &&
        validator.hasMaxLength(value, { maxLength: 7 }))
    ) {
      if (this.props.discountType === ENUMS.CAFE_DISCOUNT_VALUE_TYPES.values.PERCENT) {
        if (value <= 100) {
          this.props.onChangeDiscountValue(this.props.weekday, itemKey, value);
        }
      } else {
        this.props.onChangeDiscountValue(this.props.weekday, itemKey, value);
      }
    }
    return;
  }

  onChangeHasDiscount = (e, itemKey) => {
    const checked = e.target.checked;
    this.props.onChangeHasDiscount(this.props.weekday, itemKey, checked);
  }

  onChangeDiscountType = (e, itemKey) => {
    const value = e.target.value;
    this.props.onChangeDiscountType(this.props.weekday, itemKey, value);
  };

  render() {
    return (
      <li className={styles.weekdayHoursListItem}>
        <span className={styles.hourPair}>
          {this.props.fromTime} - {this.props.toTime}
        </span>
        <label className={`form-check-label ${styles.hasDiscountContainer}`}>
          <input
            type="checkbox"
            className={styles.hasDiscountCheckbox}
            checked={this.props.hasDiscount}
            onChange={e => this.onChangeHasDiscount(e, this.props.itemKey)}
          />
          {locales('fields.has.discount')}
        </label>
        <span className={styles.hourDiscount}>
          <input
            type="textbox"
            className={styles.discountValue}
            onChange={e => this.onChangeDiscountValue(e, this.props.itemKey)}
            value={this.props.discountValue}
            disabled={!this.props.hasDiscount}
          />
          <span className={`${styles['percentage-border']}`}>{locales('tables.percent')}</span>
          {/* <select 
            disabled={!this.props.hasDiscount} 
            onChange={e => this.onChangeDiscountType(e, this.props.itemKey)}
            value={this.props.discountType}
          >
            <option 
              value={ENUMS.CAFE_DISCOUNT_VALUE_TYPES.values.PERCENT} 
              selected={this.props.discountType === ENUMS.CAFE_DISCOUNT_VALUE_TYPES.values.PERCENT}
            >{locales('labels.percent')}</option>
            <option 
              value={ENUMS.CAFE_DISCOUNT_VALUE_TYPES.values.AMOUNT}
              selected={this.props.discountType === ENUMS.CAFE_DISCOUNT_VALUE_TYPES.values.AMOUNT}
            >{locales('labels.amount.in.toman')}</option>
          </select> */}
        </span>
      </li>
    );
  }
}

export default HourPairDiscountItem;
